@let _isMobile = isMobile();

@defer {
  @if (newsletterData) {
    <sd-modal-default
      [clickToClose]="true"
      [modalTitleLevel]="4"
      [(isOpened)]="isOpened"
      [hasHeader]="false"
      modalCustomClass="c__modal-newsletter-form"
      (isOpenedChange)="saveClosed($event)"
    >
      @if (isLoading) {
        <div sd-loader></div>
      }

      <div class="c__text {{ currentStep === 2 ? 'c__last-step' : '' }}">
        @switch (currentStep) {
          @case (0) {
            <sd-title [titleLevel]="titleLevel" customClass="brand--h2">
              <sd-icon name="icon-mail" [size]="!!_isMobile ? IconSizeEnum.large: IconSizeEnum.xxl" />
              {{ 'newsletter.offer.title' | translate }}
            </sd-title>
          }
          @case (1) {
            <sd-title [titleLevel]="titleLevel" customClass="brand--h2">
              <sd-icon name="icon-heart" [size]="!!_isMobile ? IconSizeEnum.large: IconSizeEnum.xxl" />
              {{ 'newsletter.offer.step2.title' | translate }}
            </sd-title>
          }
          @case (2) {
            <sd-title [titleLevel]="titleLevel" customClass="brand--h2">
              <sd-icon name="icon-mail" [size]="!!_isMobile ? IconSizeEnum.large: IconSizeEnum.xxl" />
              {{ 'newsletter.offer.step3.title' | translate:{firstName:form?.['firstName']} }}
            </sd-title>
          }
        }

        @if (!!formNewsletter?.get(additionalInfoGroupName)) {
          <div class="c__steps_newsletter">
            <span class="c__step-bar {{ currentStep === 0 ? 'active' : '' }}"></span>
            <span class="c__step-bar {{ currentStep === 1 ? 'active' : '' }}"></span>
            <span class="c__step-bar {{ currentStep === 2 ? 'active' : '' }}"></span>
          </div>
        }

        @if (formError) {
          <p class="error">{{ 'newsletterRegistrationPopup.error' | translate }}</p>
        }

        <wc-base-newsletter
          [newsletter]="newsletterData"
          [formNewsletter]="formNewsletter"
          [contactGroupName]="contactGroupName"
          [newsletterContext]="newsletterContext"
          [trackingContext]="trackingContext"
          [gender]="gender"
          [currentStep]="currentStep"
          [additionalInfoGroupName]="additionalInfoGroupName"
          [isIntrusive]="true"
          [isInsideModal]="true"
          [isRow]="false"
          [successMessage]="successMessage"
          [formSuccess]="formSuccess"
          [form]="form"
          [isPopin]="true"
          (closeModal)="onCloseModal()"
          (sendEmailScore)="populateEmailScore($event)"
        />
        <wc-captcha-turnstile
          (captchaTurnstileSuccess)="subscribeToNewsletter(currentStep)"
          (captchaTurnstileError)="captchaError()"
        />
      </div>

      @if (imageNewsletter) {
        <div class="c__image {{ currentStep === 2 ? 'c__full-width' : '' }}">
          <sd-banner [media]="imageNewsletter" alt="newsletter registration" />
        </div>
      }

      <div class="c__action">
        @if (currentStep === 0) {
          <form [formGroup]="legalFormGroup">
            <sd-form
              checkbox
              formControlName="formCheckbox"
              #newsletterCheckbox
              class="is-aligned-top c__newsletter-checkbox"
              customClass="is-caption"
              [labelTitle]="newsletterData?.checkboxLabel"
              nameField="agree-newsletter"
              [required]="true"
            >
              <ng-container sd-message>
                <sd-form-error
                  errorKey="required"
                  [errorLabel]="'newsletter.termsRequired' | translate"
                  [control]="legalFormGroup.get('formCheckbox')"
                />
              </ng-container>
            </sd-form>
          </form>
        }

        @if (currentStep === 0 && !!formNewsletter) {
          <form [formGroup]="formNewsletter">
            @if (!!formNewsletter.get(contactGroupName)?.get('phone')?.value) {
              <ng-container>
                <div formGroupName="{{ termsConditionGroupName }}">
                  @for (control of getControls(dynamicTermsGroup); track control) {
                    <sd-form
                      checkbox
                      formControlName="{{ control.name }}"
                      class="is-aligned-top c__newsletter-checkbox"
                      customClass="is-caption"
                      [labelTitle]="control.label"
                      [nameField]="control.name"
                      [required]="control.required"
                    >
                      <ng-container sd-message>
                        <sd-form-error
                          errorKey="required"
                          [errorLabel]="'newsletter.termsRequired' | translate"
                          [control]="dynamicTermsGroup.get(control.name)"
                        />
                      </ng-container>
                    </sd-form>
                  }
                </div>
              </ng-container>
            }
          </form>
        }

        <button sd-button type="submit" (click)="onSubmit()">
          {{ (currentStep === 0 ? 'newsletter.button.subscribe' : currentStep === 1 ? ('newsletter.step2.subscribe') :
          'newsletter.offer.step3.submit') | translate }}
        </button>
      </div>
    </sd-modal-default>
  }
}
